module.exports = __webpack_public_path__ + "media/images/application/template/flag-ch-aeea2cf17527fca3aea3d8c8a5ec1aad.png";